<template>
  <div>
    <v-layout wrap align-center class="pt-4">
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text">
          <label>Tipo Credenciamento</label>
          <p>{{ getTipoCredenciamento(licitacao.tipoCredenciamento)}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text">
          <label>Número do Processo</label>
          <p v-if="licitacao.numProcesso">{{licitacao.numProcesso}}</p>
          <p v-else>--</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text">
          <label>Amparo Legal</label>
          <p v-if="licitacao.amparoLegal">{{licitacao.amparoLegal.lei}}</p>
          <p v-else>--</p>
        </div>
      </v-flex>

      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text">
          <label v-if="licitacao.ehPerfilComprasBR">Órgão</label>
          <label v-else>Responsável</label>
          <p v-if="licitacao.nomeOrgao">{{licitacao.nomeOrgao}}</p>
          <p v-else>--</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-limite-esclarecimento-impugnacao">
          <label>Data/Hora Limite Esclarecimento/Impugnação</label>
          <p>{{licitacao.dataLimiteEsclarecimentoImpugnacao | az-date('DD/MM/YYYY HH:mm:ss')}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-inicio-envio">
          <label>Data/Hora Abertura</label>
          <p>{{licitacao.dataAbertura | az-date('DD/MM/YYYY HH:mm:ss')}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-fim-envio">
          <label>Data/Hora Fim Envio Credenciamento</label>
          <p>{{licitacao.dataFimEnvioProposta | az-date('DD/MM/YYYY HH:mm:ss')}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm12 d-flex>
        <div class="az-text">
          <label>Objeto</label>
          <p>{{licitacao.objeto}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm12 d-flex>
        <div class="az-text">
          <label>Informação Complementar</label>
          <p>{{licitacao.informacaoComplementar}}</p>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {modalidadesLicitacao, modosDisputa, tiposDisputa, tiposLicitacao} from '@/core/constants'
import momentTz from 'moment-timezone'
import tiposCredenciamento from '@/core/constants/tipos-credenciamento'

export default {
    name: 'CredenciamentoVisualizacaoDadosGerais',
    data(){
        return{
            modalidadesLicitacao,
            tiposDisputa,
            modosDisputa,
            tiposLicitacao,
            tiposCredenciamento,
        }
    },
    computed:{
        ...mapState(['licitacao']),
    },
    methods:{
        getModalidadeLicitacao(modalidade){
            return this.modalidadesLicitacao[modalidade]
        },
        getTipoCredenciamento(tipo) {
            return this.tiposCredenciamento[tipo]
        },
        tipoDisputaDesc(tipoDisputa) {
            return this.tiposDisputa[tipoDisputa]
        },
        getModoDisputa(modo) {
            return this.modosDisputa[modo]
        },
        getTipoResponsavel(modalidade){
            let tipoResponsavel = 'Pregoeiro'

            if(!modalidade) return tipoResponsavel

            if(modalidade.includes('CONCORRÊNCIA'))
                tipoResponsavel = 'Agente de Contratação'

            if(modalidade === 'LEILÃO ELETRÔNICO')
                tipoResponsavel = 'Leiloeiro'

            return tipoResponsavel
        },
        formatarDataBSB(value) {
            if (!value) return ''

            const tzDestino = 'America/Sao_Paulo'
            const format    = 'DD/MM/YYYY HH:mm:ss'

            const dataOrigem = momentTz.parseZone(value)

            return dataOrigem.tz(tzDestino).format(format)
        }
    },
    filters:{
        opcaoSimNaoFilter(valor){
            return {S: 'Sim', N: 'Não'}[valor]
        }
    }
}
</script>
<style lang="stylus" scoped>
label
  font-size 14px
  font-weight bold
</style>